import "../../assets/stylesheets/HomePages.scss";

const Pagination = ({ currentPage, nPages, pageNumbers, handleChange }) => {
  const goToNextPage = () => {
    if (currentPage !== nPages) {
      handleChange("nextPage");
    }
  };

  const goToPrevPage = () => {
    if (currentPage !== 1) {
      handleChange("lastPage");
    }
  };

  return (
    <div>
      <ul
        className="pagination justify-content-center"
        style={{ borderTop: "0" }}
      >
        <li className="page-item">
          <a className="page-link" onClick={goToPrevPage}>
            <span className="icon-xs icon-caret-spin-left"></span>
          </a>
        </li>
        {pageNumbers.map((pgNumber) => (
          <li
            key={pgNumber}
            className={`page-item ${currentPage === pgNumber ? "active" : ""} `}
          >
            <a onClick={() => handleChange(pgNumber)} className="page-link">
              {pgNumber}
            </a>
          </li>
        ))}
        <li className="page-item">
          <a className="page-link" onClick={goToNextPage}>
            <span className="icon-xs icon-caret"></span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
